import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { getAuthState } from "../redux/selectors";

export function PrivateRoute({ children, ...rest }: any) {
  const { currentUser } = useSelector(getAuthState);
  return (
    <Route
      {...rest}
      render={({ location }) =>
        currentUser ? (children) :
          (
            <Redirect
              to={{
                pathname: "/login",
                state: { from: location }
              }}
            />
          )
      }
    />
  )
}
